// src/api/siteGroupAPI.js
import apiClient from './client';

const SITE_GROUPS_URL = '/api/v1/site_groups/';
const COMPANY_SITE_GROUPS_URL = '/api/v1/companies/';

// Get all site groups
export const getSiteGroups = async (companyId, enabled) => {
  try {
    const params = {};
    if (companyId !== undefined) params.company_id = companyId;
    if (enabled !== undefined) params.enabled = enabled;

    const response = await apiClient.get(SITE_GROUPS_URL, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching site groups:', error);
    throw error;
  }
};

// Get all site groups for a specific company
export const getCompanySiteGroups = async (companyId, enabled) => {
  try {
    const params = enabled !== undefined ? { enabled } : {};
    const response = await apiClient.get(`${COMPANY_SITE_GROUPS_URL}${companyId}/site_groups`, { params });
    return response.data;
  } catch (error) {
    console.error(`Error fetching site groups for company ${companyId}:`, error);
    throw error;
  }
};

// Get a single site group by ID
export const getSiteGroup = async (siteGroupId) => {
  try {
    const response = await apiClient.get(`${SITE_GROUPS_URL}${siteGroupId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching site group ${siteGroupId}:`, error);
    throw error;
  }
};

// Create a new site group
export const createSiteGroup = async (siteGroupData) => {
  try {
    const response = await apiClient.post(SITE_GROUPS_URL, siteGroupData);
    return response.data;
  } catch (error) {
    console.error('Error creating site group:', error);
    throw error;
  }
};

// Update a site group
export const updateSiteGroup = async (siteGroupId, siteGroupData) => {
  try {
    const response = await apiClient.put(`${SITE_GROUPS_URL}${siteGroupId}`, siteGroupData);
    return response.data;
  } catch (error) {
    console.error(`Error updating site group ${siteGroupId}:`, error);
    throw error;
  }
};

// Delete a site group
export const deleteSiteGroup = async (siteGroupId) => {
  try {
    await apiClient.delete(`${SITE_GROUPS_URL}${siteGroupId}`);
  } catch (error) {
    console.error(`Error deleting site group ${siteGroupId}:`, error);
    throw error;
  }
};